import React, {Component} from 'react'
import {validate, isFormValid} from '../functions/Validation';
import BaseComponent from "../common/BaseComponent";
import update from 'immutability-helper';

class FormComponent extends BaseComponent {

    validationList = {};

    constructor(props) {
        super(props);

        this.state = {
            data: {},
            errors: {},
            showLoader: false,
            dataHasChanged: false
        };

        this.changeData = this.changeData.bind(this);
        this.changeCheckBox = this.changeCheckBox.bind(this);
        this.handleButtonClick = this.handleButtonClick.bind(this);
        this.validate = this.validate.bind(this);
        this.scrollToError = this.scrollToError.bind(this);
    }

    changeData(event, data = 'data') {

        this.setState({
            [data]: update(this.state[data], { [event.target.name]: {$set: event.target.value} })
        });
    }

    changeCheckBox(event) {

        if(event.target.name !== undefined){
            const field = event.target.name;
            const data = this.state.data;
            data[field] = !data[field];            
            console.log(data[field])
            this.setState({
                data,
                dataHasChanged: true
            });
        }
    }

    handleButtonClick(event, name, value){
        const field = name;
        const data = this.state.data;
        data[field] = value;

        this.setState({
            data: data
        });
    }

    isNumeric(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }

    isFloat(n) {
        return !isNaN(parseFloat(n));
    }

    isInt(n) {
        return isFinite(n)
    }

    validate () {

        let errors = validate(this.state.data, this.validationList);
        console.log(errors);
        this.setState({errors});

        for(let error in errors){
            if(errors[error][0] !== undefined){

                let offsetTop = '';
                let eleName = document.getElementsByName(error);
                let eleId = document.getElementById(error);

                if(eleId !== null){
                    offsetTop = eleId.parentElement.offsetTop;
                    window.scrollTo(0, offsetTop - 140);
                    break;
                }else {
                    if(eleName[0] !== undefined){
                        offsetTop = eleName[0].getBoundingClientRect().top;

                        if(errors[error][0].message !== undefined){
                            window.scrollTo(0, window.pageYOffset + offsetTop - 140);
                            break;
                        }
                    }
                }
            }
        }

        return isFormValid(errors);
    }

    scrollToError(errors) {
        for(let error in errors){
            if(errors[error][0] !== undefined){

                let offsetTop = '';
                let eleName = document.getElementsByName(error);
                let eleId = document.getElementById(error);

                if(eleId !== null){
                    offsetTop = eleId.parentElement.offsetTop;
                    window.scrollTo(0, offsetTop - 140);
                    break;
                }else {
                    if(eleName[0] !== undefined){
                        offsetTop = eleName[0].getBoundingClientRect().top;

                        if(errors[error][0].message !== undefined){
                            window.scrollTo(0, window.pageYOffset + offsetTop - 140);
                            break;
                        }
                    }
                }
            }
        }
    }

    setError(key, value) {
        this.setState({
            errors: update(this.state.errors, { [key]: {$set: [ { message: value} ]} })
        });
    }

    showDrawerLoader() {
        this.setState({
            showLoader: true
        });
    }

    hideDrawerLoader() {
        this.setState({
            showLoader: false
        });
    }
}

export default FormComponent;